import { Badge, Button, Input } from '../../../components/ui';
import { Tile, TileBody, TileHeader } from '../../../components/shared';
import { useT } from '../../../i18n';

export function XemTruoc() {
  const { t } = useT();
  return (
    <Tile span="xl:col-span-4" className="xl:sticky xl:top-4 xl:self-start">
      <TileHeader tone="primary" title={t('tuyChinh.mauNhanh')} />
      <TileBody className="space-y-4">
        <div className="flex flex-wrap items-center gap-2">
          <Button variant="primary" size="sm">
            {t('tuyChinh.nutChinh')}
          </Button>
          <Button variant="secondary" size="sm">
            {t('tuyChinh.nutPhu')}
          </Button>
          <Button variant="destructive" size="sm">
            {t('chung.xoa')}
          </Button>
        </div>
        <Input size="small" placeholder={t('tuyChinh.oNhap')} />
        <div className="flex flex-wrap gap-1.5">
          <Badge variant="primary">{t('tuyChinh.nhanMauNhan')}</Badge>
          <Badge variant="success">{t('tuyChinh.nhanXong')}</Badge>
          <Badge variant="warning">{t('tuyChinh.nhanCho')}</Badge>
          <Badge variant="danger">{t('tuyChinh.nhanLoi')}</Badge>
        </div>
        <ul aria-hidden className="space-y-1 rounded-lg border border-default bg-subtle p-2">
          <li className="rounded bg-primary-50 px-3 py-1.5 text-sm font-medium text-primary-700">
            {t('tuyChinh.mucDangChon')}
          </li>
          <li className="rounded px-3 py-1.5 text-sm text-content-secondary">{t('tuyChinh.mucKhac')}</li>
        </ul>
      </TileBody>
    </Tile>
  );
}
